import { createStyles, makeStyles, fade, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    infoRow: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 24,
      paddingBottom: SMALL_MARGIN / 2,
      borderBottom: `1px solid ${fade(colorsPalette.white, 0.33)}`,
      [theme.breakpoints.up('sm')]: {
        display: 'block',
        paddingBottom: 0,
        borderBottom: 0,
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
    infoTitle: {
      display: 'inline',
    },
    infoText: {
      marginLeft: SMALL_MARGIN / 2,
      display: 'inline',
    },
  }),
);

export default useStyles;
